export const createTestId = (
  ...args: (string | number | null | undefined)[]
) => {
  return `app-header-${args.filter((a) => !!a).join('-')}`;
};
